// API config voor frontend
// Gebruik deze base URL voor alle API-aanroepen
// Tijdens lokaal testen: http://localhost:7071/api
// In productie: relative path (bijv. /api)

// Bepaal API base URL op basis van hostnaam: localhost => lokale Functions, anders => '/api'
const isLocalhost =
  typeof window !== "undefined" &&
  window.location &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "0.0.0.0");

// Een parallelle lokale instantie (script/local-acc.sh, LOCAL_ACC_INSTANCE) zet de API-poort via VITE_LOCAL_API_PORT.
const LOCAL_API_PORT = import.meta.env?.VITE_LOCAL_API_PORT || "7071";

export const API_BASE_URL = isLocalhost ? `http://localhost:${LOCAL_API_PORT}/api` : "/api";
